import './usd/style';
import FormStructure from './usd/form_structure';

export default FormStructure;